import { render } from "./CookiesSignIn.vue?vue&type=template&id=41695a99&scoped=true&ts=true&lang=ts"
import script from "./CookiesSignIn.vue?vue&type=script&lang=ts"
export * from "./CookiesSignIn.vue?vue&type=script&lang=ts"

import "./CookiesSignIn.vue?vue&type=style&index=0&id=41695a99&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41695a99"]])

export default __exports__